module.exports = __webpack_public_path__ + "img/img3zhTc.a7acccc9.png";